import type { RouteRecordRaw } from 'vue-router';
import { AUTH_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const staffLoginRoutes: RouteRecordRaw = {
  path: '/auth/staff-login',
  component: () => import('@/layouts/public.vue'),
  meta: { i18n },
  children: [
    {
      path: '',
      name: AUTH_ROUTE_NAME.STAFF_LOGIN,
      component: () => import('./StaffLogin.vue'),
      meta: { onlyGuest: true },
    },
  ],
};
